import apiClient, { extractData } from "./client";

export async function getTransportLines(params = {}) {
  const response = await apiClient.get("/transport-lines", { params });
  return extractData(response);
}

export async function getTransportLine(id) {
  const response = await apiClient.get(`/transport-lines/${id}`);
  return extractData(response);
}

export async function createTransportLine(data) {
  const response = await apiClient.post("/transport-lines", data);
  return extractData(response);
}

export async function updateTransportLine(id, data) {
  const response = await apiClient.patch(`/transport-lines/${id}`, data);
  return extractData(response);
}

export async function assignTransportLineEmployees(id, employeeIds) {
  const response = await apiClient.post(`/transport-lines/${id}/employees`, {
    employeeIds,
  });
  return extractData(response);
}

export async function unassignTransportLineEmployees(id, employeeIds) {
  const response = await apiClient.post(
    `/transport-lines/${id}/employees/unassign`,
    { employeeIds },
  );
  return extractData(response);
}

export async function getTransportLineAdjustments(id, params = {}) {
  const response = await apiClient.get(`/transport-lines/${id}/adjustments`, {
    params,
  });
  return extractData(response);
}

export async function upsertTransportLineAdjustment(id, data) {
  const response = await apiClient.put(
    `/transport-lines/${id}/adjustments`,
    data,
  );
  return extractData(response);
}

export async function deleteTransportLineAdjustment(id, date) {
  const response = await apiClient.delete(
    `/transport-lines/${id}/adjustments/${date}`,
  );
  return extractData(response);
}
